import React, { useState } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  Tab,
  Popper,
  Paper,
  List,
  MenuItem,
  ListItemIcon,
  ListItemText,
  ListSubheader
 } from '@material-ui/core';

const TabDropdown = ({
  classes,
  location,
  tabClasses,
  label,
  value,
  menuItems,
  handleMenuItemClick,
  staticContext,
  disabled,
  menuItemsDisabled,
  handleMenuOpen,
  isMenuOpen,
  ...rest
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openPopover = (e) => {
    setAnchorEl(e.currentTarget);
    handleMenuOpen(value);
  }

  const onBlur = (e) => {
    const targetEl = e?.target?.getAttribute('role');
    const relatedTargetEl = e?.relatedTarget?.getAttribute('role');
    if (![targetEl, relatedTargetEl].includes('menuitem')) {
      closePopover();
    }
  }

  const closePopover = () => {
    setAnchorEl(null);
    handleMenuOpen(null);
  }

  const handleClick = (route) => {
    closePopover();
    handleMenuItemClick(route);
  }

  const isSelected = (menuItem) => {
    const occurrences = menuItems.filter(menuItem => location.pathname.includes(menuItem.route)).length;
    if (occurrences > 1) {
      return location.pathname === menuItem.route;
    } else {
      return location.pathname.includes(menuItem.route);
    }
  }

  return (
    <div
      className={classes.dropdownRoot}
      onBlur={onBlur}
    >
      <Tab
        classes={{...tabClasses, disabled: classes.disabledTab}}
        style={anchorEl
          ? { opacity: 0.85 }
          : {}
        }
        label={label}
        value={value}
        onClick={openPopover}
        disabled={disabled}
        {...rest}
      />
      {menuItems?.length &&
        <Popper
          open={isMenuOpen}
          anchorEl={anchorEl}
          style={{ zIndex: 1101 }}
          placement='bottom-start'
        >
          <Paper elevation={8} className={classes.paper}>
            <List>
              {menuItems.map(menuItem => {
                if (menuItem.subheader) {
                  return <ListSubheader key={menuItem.subheader}>{menuItem.subheader}</ListSubheader>
                }
                return (
                  <MenuItem
                    key={menuItem.route}
                    onClick={() => handleClick(menuItem.route)}
                    selected={isSelected(menuItem)}
                    disabled={menuItemsDisabled || menuItem.disabled}
                  >
                    {menuItem.icon &&
                      <ListItemIcon className={classes.listItemIcon}>
                        {menuItem.icon}
                      </ListItemIcon>
                    }
                    <ListItemText primary={menuItem.label} />
                  </MenuItem>
                )
              })}
            </List>
          </Paper>
        </Popper>
      }
    </div>
  );
};

const styles = theme => ({
  dropdownRoot: {
    '&:hover': { zIndex: 1 }
  },
  paper: {
    borderRadius: '0 0 4px 4px'
  },
  listItemIcon: {
    minWidth: 40
  },
  disabledTab: {
    opacity: '1!important',
    color: '#afafaf'
  }
});

export default compose(
  withRouter,
  withStyles(styles)
)(TabDropdown);
